// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__yG7SB","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__27DQ1"};